<div *ngIf="inLoading" class="local-inLoading">
    <div class="local-loader-vail"></div>
    <div class="local-loader">
        <div class="loader">
            <svg *ngIf="!loaderTemplate" class="circular-loader" viewBox="25 25 50 50">
                <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#70c542" stroke-width="2" />
            </svg>
            <ng-container *ngIf="loaderTemplate">
                <ng-template [ngTemplateOutlet]="loaderTemplate">
                </ng-template>
            </ng-container>
        </div>
    </div>
</div>